import type { FunctionComponent, PropsWithChildren } from 'react';

import Link from './Link';
import type { LinkProps } from './Link';

export const DOCS_URL = 'https://docs.fossa.com/docs';

/**
 * Check if a string begins with "/"
 */
const startsWithSlash = (str = '') => str.charAt(0) === '/';

/**
 * Construct the docs URL
 */
export const getDocsUrl = (to = '') => `${DOCS_URL}${startsWithSlash(to) ? '' : '/'}${to}`;

const defaultProps: PropsWithChildren<LinkProps> = {
  to: '',
  children: null,
  openInNewTab: true,
};

/**
 * A <Link /> with "https://docs.fossa.com/docs" prefixed to the "to" prop
 */
const DocsLink: FunctionComponent<LinkProps> = ({ to, ...props } = defaultProps) => (
  <Link
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
    to={getDocsUrl(to)}
    openInNewTab
  />
);

export default DocsLink;
